export default {"src":"/_next/static/media/virgin-atlantic-holidays.c229be9e.svg","height":48,"width":126,"blurWidth":0,"blurHeight":0};